import { FC, useCallback, useState } from 'react';
import { Button, Form, Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthDispatchContext } from 'providers/Auth';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { Content, LinkWrapper } from './styled';
import { MessageEmailCheck, ResendButton } from '../components';

const { Title } = Typography;

const ForgetPassword: FC = () => {
  // translation
  const { t } = useTranslation();
  // router
  const navigate = useNavigate();
  // form
  const [form] = Form.useForm();
  // context
  const { forgot } = useAuthDispatchContext();
  // state
  const [isLoading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

  const onFinish = useCallback(
    values => {
      setLoading(true);
      forgot(values.email)
        .then(() => {
          setEmail(values.email);
        })
        .catch(e => {
          if (e?.errors) {
            form.setFields(e?.errors);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [forgot, form]
  );

  return (
    <>
      {email ? (
        <MessageEmailCheck title={t('auth.reset_email_title')}>
          {t('auth.reset_email_description')}
          <ResendButton
            route="/auth/forgot-password"
            email={email}
            text={t('auth.reset_email_resend')}
          />
          <Button
            type="primary"
            onClick={() => navigate('/login')}
            shape="round"
            style={{ marginTop: 12 }}
            block
          >
            {t('auth.login')}
          </Button>
        </MessageEmailCheck>
      ) : (
        <Content>
          <Title level={2} style={{ marginBottom: 24 }}>
            {t('auth.reset_password')}
          </Title>
          <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
            <Form.Item
              name="email"
              rules={[{ required: true, type: 'email' }]}
              style={{ marginBottom: 24 }}
              messageVariables={{ label: t('auth.email') }}
            >
              <Input placeholder={t('auth.email')} />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                loading={isLoading}
                block
              >
                {t('common.submit')}
              </Button>
            </Form.Item>
            <LinkWrapper>
              <Link
                to="/login"
                style={{ fontSize: 12, color: 'var(--text-color)' }}
              >
                <ArrowLeftOutlined style={{ marginRight: 12 }} />
                {t('auth.back_login')}
              </Link>
            </LinkWrapper>
          </Form>
        </Content>
      )}
    </>
  );
};

export default ForgetPassword;
